import React from "react";
import BugComponent from "./BugComponent";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
  }

  render() {
    return this.state.hasError ? <BugComponent /> : this.props.children;
  }
}

export default ErrorBoundary;
